import React from "react";
import { FaMapMarkerAlt, FaCompass } from "react-icons/fa";
import { SITE_CONTENT } from "../content";

const ServiceAreasSection = () => {
  const { subtitle, title, areas, note } =
    SITE_CONTENT.pages.homePage.serviceAreasSection;

  return (
    <section className="bg-[#07160d] text-white py-24 lg:py-32 relative overflow-hidden" id="service-areas">
      {/* Background Ambience */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[650px] h-[650px] bg-[#006B54]/15 rounded-full blur-[160px] pointer-events-none" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10 text-center">
        
        {/* Header */}
        <span className="inline-block px-4 py-1.5 rounded-full border border-[#E8A040]/30 bg-[#E8A040]/10 text-[#E8A040] text-xs font-bold tracking-[0.25em] uppercase mb-4 shadow">
          {subtitle}
        </span>

        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light font-serif text-[#f8f4ee] mb-4">
          {title}
        </h2>
        <div className="w-20 h-1 bg-gradient-to-r from-transparent via-[#E8A040] to-transparent mx-auto mb-14" />

        {/* 16 Cities Interactive Pill Grid */}
        <div className="flex flex-wrap justify-center items-center gap-3 sm:gap-4 max-w-4xl mx-auto mb-14">
          {areas.map((area, idx) => (
            <div
              key={idx}
              className="group flex items-center gap-2 px-5 py-3 rounded-full bg-[#0d2617]/90 border border-[#204a2f] text-white/90 text-sm font-medium shadow-sm hover:border-[#E8A040] hover:bg-[#123820] hover:scale-105 transition-all duration-300 cursor-default"
            >
              <FaMapMarkerAlt className="w-3.5 h-3.5 text-[#E8A040] group-hover:scale-110 transition-transform" />
              <span>{area}</span>
            </div>
          ))}
        </div>

        {/* Outstation travel note */}
        <div className="p-6 rounded-2xl bg-[#0b2013]/70 border border-[#235032] inline-flex items-center gap-3 text-sm text-[#d4ded7] font-light max-w-2xl mx-auto shadow-inner">
          <FaCompass className="text-[#E8A040] w-5 h-5 shrink-0" />
          <p>
            {note}
          </p>
        </div>

      </div>
    </section>
  );
};

export default ServiceAreasSection;
